module.exports = __webpack_public_path__ + "static/media/pastevent4.c8374acd.jpg";